import type { IntegrationListItemType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Alert } from "../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierRelationshipIntegrationValuesUpdate } from "../../../../hooks/api/v2/supplierRelationshipIntegrationValues/useSupplierRelationshipIntegrationValuesUpdate";
import { ConnectionIntegrationValuesRow } from "./ConnectionIntegrationValuesRow";

export function ConnectionIntegrationValuesUpdate({
  integration,
  integrationValueId,
  connectionId,
}: {
  integration: IntegrationListItemType;
  connectionId: number;
  integrationValueId: number;
}): ReactElement | null {
  const updateIntegrationValueMutation =
    useSupplierRelationshipIntegrationValuesUpdate(integrationValueId);

  const onSubmit = (value: string) => {
    if (integration.id) {
      updateIntegrationValueMutation.mutate({
        value,
        IntegrationId: integration.id,
        SupplierRetailerConnectionId: connectionId,
      });
    }
  };

  return (
    <>
      {updateIntegrationValueMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(updateIntegrationValueMutation.error)?.response
              ?.data.message ?? "An unknown error occurred"
          }
        />
      )}
      <ConnectionIntegrationValuesRow
        integration={integration}
        onSubmit={(e) => onSubmit(e)}
        loading={updateIntegrationValueMutation.isPending}
      />
    </>
  );
}
